import Cookies from 'js-cookie';
import actions from './actions';
import { DataService } from '../../config/dataService/dataService';

const { loginBegin, loginSuccess, loginErr, logoutBegin, logoutSuccess, logoutErr } = actions;

const login = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(loginBegin());
      const res = await DataService.post(`/login`, payload);
      if (res.data.response.success === false) {
        dispatch(loginErr('unauthorized'));
      } else {
        dispatch(loginSuccess(true));
      }
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const logOut = () => {
  return async (dispatch) => {
    try {
      dispatch(logoutBegin());
      Cookies.remove('logedIn');
      dispatch(logoutSuccess(null));
    } catch (err) {
      dispatch(logoutErr(err));
    }
  };
};

export { login, logOut };
